module.exports = __webpack_public_path__ + "img/medal.eac5053.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/honor_system/medal.png
// module id = 5o/c
// module chunks = 15